import { API_BASE_URL } from "@lib/config";
import { shouldTrackSearch } from "./session";

type SearchEventPayload = Record<string, unknown>;

const safePost = async (url: string, payload: SearchEventPayload) => {
  if (!shouldTrackSearch()) return;
  try {
    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Search event failed", error);
    }
  }
};

export const sendSearchEvents = async (payload: SearchEventPayload) => {
  return safePost(`${API_BASE_URL}/public/search/events`, payload);
};

export const sendSearchClick = async (payload: SearchEventPayload) => {
  return safePost(`${API_BASE_URL}/public/search/click`, payload);
};
